/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import { ScreenRedirect } from '@jira/platform__routing-screen-redirect/src/ui/ScreenRedirect.tsx';
import { useRouter } from '@atlassian/react-resource-router';

const GinBrowseIssuesRedirect = (): React.JSX.Element => {
	const [{ match }] = useRouter();

	const issueKey = match.params.issueKey ?? '';

	return <ScreenRedirect to={`/issues/${issueKey}`} />;
};

export default GinBrowseIssuesRedirect;
